import { TokenPair } from '../client/auth-store';
import { ImpersonationView } from '../session/session';
/**
 * « Log in as this member » (16 Oct 2026) — the legacy site's « Switch To ».
 *
 * The back office opens `/account/impersonate#code=…` in a new tab. The code is
 * one-time and lives a minute; this page trades it for a thirty-minute viewing
 * session of its own, held in **this tab only** so it never replaces anybody's
 * own session in the browser. « Return to admin » ends it on the server at once.
 */
export const IMPERSONATION_PATH = '/account/impersonate';
export const RedeemedImpersonation = TokenPair.extend({ impersonation: ImpersonationView });
export function redeemImpersonation(http, code) {
    return http.post('/auth/impersonation/redeem', { code }, { schema: RedeemedImpersonation });
}
/** « Return to admin »: the server marks the session ended and revokes its tokens. */
export function endImpersonation(http) {
    return http.post('/auth/impersonation/end', undefined);
}
//# sourceMappingURL=impersonation.js.map